import WavefunctionTheory from "../content/wavefunction.mdx";

/**
 * ABWavefunction — Section 5: Time-dependent wavefunction evolution.
 */
export function ABWavefunction() {
  return (
    <div className="flex flex-col gap-8 p-6 max-w-4xl mx-auto">
      <div className="mdx-content">
        <WavefunctionTheory />
      </div>
    </div>
  );
}